import styled from 'styled-components';
import tokens from 'assets/styles/tokens';

export const CardContent = styled.div`
  background-color: ${tokens.colors.white};
  box-shadow: 0px 8px 24px rgba(11, 0, 21, 0.04);
  border-radius: 8px;
  display: table;
`;
